export const TAB_INACCURATE = 'inaccurate';
export const TAB_UNFULFILLED = 'unfulfilled';

export const GLOSSARY_TAB_INACCURATE = 'inaccurate';
export const GLOSSARY_TAB_CANCELLED = 'cancelled';
export const GLOSSARY_TAB_ONLINE_RATE = 'online_rate';

export const GLOSSARY_INACCURATE_INTRO =
  "These are issues that reflect whether you've prepared orders according to eater specifications";
export const GLOSSARY_INACCURATE_RATE =
  'Includes all orders with inaccuracies whether or not you were charged. Excludes orders with fraudulent claims.';
export const GLOSSARY_ITEMS_MISSING = 'Items were missing';
export const GLOSSARY_MISSING_CUSTOMIZATIONS = 'Customizations were missing';
export const GLOSSARY_WRONG_ORDER =
  "The order received was either someone else's or completely wrong";

export const GLOSSARY_CANCELLED_INTRO = "These are issues where customers did not receive an order";
export const GLOSSARY_UNFULFILLED_RATE =
  'Percentage of all orders cancelled by you, whether you did so deliberately or did not confirm an order on time.';
export const GLOSSARY_UNACCEPTED =
  'Order was not confirmed within the allotted time on the orders app';
export const GLOSSARY_CANCELLED = "You cancelled the incoming order";

export const GLOSSARY_ONLINE_RATE =
  'The percentage of time your shop(s) were online during menu hours.';
